const baseUrl = 'http://read.com'
//const baseUrl = 'https://admin.xichuanwh.com/'


export default{
	baseUrl
}